import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return [
      "licenseDetailsContainer",
      "giftSends",
      "giftSendsMessage",
      "contractStartDate",
      "contractStartDateMessage",
      "contractEndDate",
      "contractEndDateMessage"
    ];
  }

  // bootstrap-datepicker announces a picked date with its jQuery-only "changeDate" event, which
  // no addEventListener ever sees, so a `change->` data-action here would be dead. Its own
  // `.datepicker(...)` API calls in syncEndDate stay jQuery for the same reason (R8 plugin
  // allowlist).
  //
  // The four *Message() methods stay on window.ltFormValidators (D3: same shared helper as
  // validation_controller.js) whose show/hideValidationErrorMessage take a jQuery object
  // (`($message) => $message.show()` in lt_form_validators.js) -- changing that boundary is a
  // cross-controller change (edit_account_balance and platform_license_edit also call it), out of
  // this unit's scope.
  connect() {
    $(this.contractStartDateTarget).datepicker().on("changeDate.platformLicenseNew", (event) => this.syncEndDate(event));
  }

  disconnect() {
    $(this.contractStartDateTarget).off("changeDate.platformLicenseNew");
  }

  showDetails() {
    // #license-details-container has a plain (non-!important) `display: none` in
    // admin/platform_licenses.scss -- jQuery 3's `.show()` writes the tag's default display
    // ("block") back as an inline style so it outranks that rule; `""` would just clear the
    // inline style and let the stylesheet's `display: none` win (pattern 11).
    this.licenseDetailsContainerTarget.style.display = "block";
  }

  hideDetails() {
    this.licenseDetailsContainerTarget.style.display = "none";
  }

  syncEndDate(event) {
    const selectedDate = event.date;
    const newEndDate = new Date(selectedDate.getFullYear() + 1, selectedDate.getMonth(), selectedDate.getDate());

    $(this.contractEndDateTarget).datepicker("setDate", newEndDate);
    $(event.currentTarget).datepicker("hide");
  }

  clearGiftSendsMessage() {
    window.ltFormValidators.hideValidationErrorMessage($(this.giftSendsMessageTarget));
  }

  clearContractStartDateMessage() {
    window.ltFormValidators.hideValidationErrorMessage($(this.contractStartDateMessageTarget));
  }

  clearContractEndDateMessage() {
    window.ltFormValidators.hideValidationErrorMessage($(this.contractEndDateMessageTarget));
  }

  validate(event) {
    let valid = true;

    if (window.ltFormValidators.isBlank(this.giftSendsTarget.value) || !window.ltFormValidators.isInteger(this.giftSendsTarget.value)) {
      window.ltFormValidators.showValidationErrorMessage($(this.giftSendsMessageTarget));
      valid = false;
    }

    if (window.ltFormValidators.isBlank(this.contractStartDateTarget.value)) {
      window.ltFormValidators.showValidationErrorMessage($(this.contractStartDateMessageTarget));
      valid = false;
    }

    if (window.ltFormValidators.isBlank(this.contractEndDateTarget.value)) {
      window.ltFormValidators.showValidationErrorMessage($(this.contractEndDateMessageTarget));
      valid = false;
    }

    if (!valid) {
      event.preventDefault();
    }
  }
}
